import 'es6-promise/auto';
import Vue from 'vue';
import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';
Vue.use(ViewUI);
import VueLazyload from 'vue-lazyload';
Vue.use(VueLazyload);
import App from '../pages/index.vue';
import apm from 'apm';
Vue.config.productionTip = false;
Vue.use(apm);
window.winVue = new Vue({el: '#root', template: '<App/>',components: { App } });



// WEBPACK FOOTER //
// ./pc/index/build/index.js